import React from 'react';
import * as S from './Switch.styles';

export type SwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  id?: string;
};

export const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  disabled,
  label,
  id = 'switch',
}) => {
  return (
    <S.SwitchContainer>
      <S.SwitchInput
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <S.SwitchLabel htmlFor={id} disabled={disabled}>
        <S.Slider checked={checked} disabled={disabled} />
      </S.SwitchLabel>
      {label && <label htmlFor={id}>{label}</label>}
    </S.SwitchContainer>
  );
};
